import React, { useRef } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import StoryblokService from "../utils/storyblok-service";
import ProgressBar from "src/components/ProgressBar";
import favicon from "/static/tlf-research-favicon.png";

export default function Layout({ children, location, isEditor, postInfo }) {
  const { settings } = useStaticQuery(graphql`
    query Settings {
      settings: allStoryblokEntry(
        filter: { field_component: { eq: "settings" } }
      ) {
        edges {
          node {
            name
            full_slug
            content
          }
        }
      }
    }
  `);
  let content = JSON.parse(settings.edges[0].node.content);
  let parsedSetting = Object.assign({}, content, { content: content });

  // Set the ref for the article height
  const articleRef = useRef();
  // Set allowed post types/components for the progress bar
  const componentsForProgressBar = [
    "news_and_opinion",
    "magazine",
    "book_review",
  ];
  let progressBarEnabled = componentsForProgressBar.includes(postInfo?.content?.component) ? true : false;

  return (
    <div className="bg-white">
      {isEditor ? (
        <>
          <Helmet
            script={[
              {
                src: `//app.storyblok.com/f/storyblok-latest.js?t=${StoryblokService.token}`,
                type: "text/javascript",
              },
            ]}
          />
          <Helmet
            script={[
              {
                innerHTML: `var StoryblokCacheVersion = '${StoryblokService.getCacheVersion()}';`,
                type: "text/javascript",
              },
            ]}
          />
        </>
      ) : null}
      <Helmet>
        <link rel="icon" href={favicon} />
        <script
          src="https://kit.fontawesome.com/b1c70f5e3d.js"
          crossorigin="anonymous"
          defer
          async
          rel="preload"
        ></script>
        <link
          rel="stylesheet"
          href="https://use.typekit.net/yyc6nmq.css"
          defer
          async
        ></link>
      </Helmet>
      <Header settings={parsedSetting} />
      {progressBarEnabled && (
        <ProgressBar post={postInfo} articleRef={articleRef} />
      )}
      <main className="text-darkgrey" ref={articleRef}>
        {children}
      </main>
      <Footer settings={parsedSetting} />
    </div>
  );
}
